import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.employeesProfilebuilder
)

export const selectFormId = createSelector(
    baseSelector,
    (state) => state.formId
)

export const selectFormFields = createSelector(
    baseSelector,
    (state) => state.formFields
)

export const selectFormError = createSelector(
    baseSelector,
    (state) => state.formError
)

export const selectFormLoading = createSelector(
    baseSelector,
    (state) => state.isFormLoading
)

export const selectFormFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFormFirstLoad
)